import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import PointLocator from '../../algorithm/PointLocator';
import Location from '../../geom/Location';
import TreeSet from '../../../../../java/util/TreeSet';
import GeometryCombiner from '../../geom/util/GeometryCombiner';
import CoordinateArrays from '../../geom/CoordinateArrays';
var PointGeometryUnion = /*#__PURE__*/function () {
  function PointGeometryUnion() {
    _classCallCheck(this, PointGeometryUnion);
    PointGeometryUnion.constructor_.apply(this, arguments);
  }
  _createClass(PointGeometryUnion, [{
    key: "union",
    value: function union() {
      var locater = new PointLocator();
      var exteriorCoords = new TreeSet();
      for (var i = 0; i < this._pointGeom.getNumGeometries(); i++) {
        var point = this._pointGeom.getGeometryN(i);
        var coord = point.getCoordinate();
        var loc = locater.locate(coord, this._otherGeom);
        if (loc === Location.EXTERIOR) exteriorCoords.add(coord);
      }
      if (exteriorCoords.size() === 0) return this._otherGeom;
      var ptComp = null;
      var coords = CoordinateArrays.toCoordinateArray(exteriorCoords);
      if (coords.length === 1) ptComp = this._geomFact.createPoint(coords[0]);else ptComp = this._geomFact.createMultiPointFromCoords(coords);
      return GeometryCombiner.combine(ptComp, this._otherGeom);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._pointGeom = null;
      this._otherGeom = null;
      this._geomFact = null;
      var pointGeom = arguments[0],
        otherGeom = arguments[1];
      this._pointGeom = pointGeom;
      this._otherGeom = otherGeom;
      this._geomFact = otherGeom.getFactory();
    }
  }, {
    key: "union",
    value: function union(pointGeom, otherGeom) {
      var unioner = new PointGeometryUnion(pointGeom, otherGeom);
      return unioner.union();
    }
  }]);
  return PointGeometryUnion;
}();
export { PointGeometryUnion as default };